import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FeatherIcon } from '../../components/FeatherIcon'
import { canStory, type VaultItem } from './vaultData'

export type SendTarget = 'post' | 'postTab' | 'message' | 'story'

/** The vault's "Add to" menu on OnlyFans: a new post (here or in a new tab), a new message, the story. */
export function SendMenu({ selection, newTab, onPick, onClose }: { selection: VaultItem[]; newTab: boolean; onPick: (target: SendTarget) => void; onClose: () => void }) {
  const { t } = useTranslation('library')
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])
  const story = canStory(selection)
  const items: ReadonlyArray<readonly [SendTarget, string, string, boolean]> = [
    ['post', 'plus-square', t('vault.send.post'), true],
    ...(newTab ? [['postTab', 'external-link', t('vault.send.postTab'), true] as const] : []),
    ['message', 'message-square', t('vault.send.message'), true],
    ['story', 'plus-circle', t('vault.send.story'), story],
  ]
  return (
    <>
      <div className="lib-backdrop" onClick={onClose} />
      <div className="lib-pop lib-menu" role="menu" aria-label={t('vault.send.title', { count: selection.length })}>
        <span className="lib-menu-head">{t('vault.send.title', { count: selection.length })}</span>
        {items.map(([target, icon, label, enabled]) => (
          <button
            key={target}
            type="button"
            role="menuitem"
            className="lib-menu-item"
            disabled={!enabled}
            title={enabled ? undefined : t('vault.send.storyOne')}
            onClick={() => onPick(target)}
          >
            <FeatherIcon name={icon} size={16} />
            <span className="lib-menu-label">{label}</span>
          </button>
        ))}
      </div>
    </>
  )
}
